import Fnc from '../usefull';
// const strtotime = require('strtotime');
let rules = [];

const validationRules = {
        optional: {rule: 'optional', message: '', priority: 0},
        required: {rule: 'required', message: 'Field __key__ is required', priority: 0},
        type: {rule: 'typeof', message: 'Invalid data type for __key__, expecting __value__', priority: 1},
        date: {rule: 'date', message: '__key__ must be a valid date. date: __value__', priority: 1},
        email: {rule: 'email', message: '__key__ is not valid as email format', priority: 1},
        boolean: {rule: 'boolean', message: 'Expected boolean with __value__ value for property __key__'} ,
        gt: {rule: 'gt', message: '__key__ must be a number greatter than __value__', argType: 'string', priority: 2},
        lt: {rule: 'lt', message: '__key__ must be lower than __value__', argType: 'string', priority: 2},
        gte: {rule: 'gte', message: '__key__ must be greatter or equal than __value__', argType: 'number', priority: 2},
        lte: {rule: 'lte', message: '__key__ must be lower or equal than __value__', argType: 'number', priority: 2},
        min: {rule: 'min', message: '__key__ must have at least __value__ characters', argType: 'string', priority: 2},
        max: {rule: 'max', message: '__key__ must have less than __value__ characters', argType: 'string', priority: 2},
        in: {rule: 'in', message: 'Invalid value for __key__', priority: 3}
        /*
        {key: 'gt', message: '__key__ must be greatter than __value__'},
        {key: 'gt', message: '__key__ must be greatter than __value__'},
        {key: 'gt', message: '__key__ must be greatter than __value__'},*/
    };

class Rule {
    static validationRules = validationRules;
    static defaultOptions = {
        valueSeparator: '&',
        replaceOnMessages: [],
        typeSeparator: '&'
    };

    /**
     * @param (String|Object rule) 'rule:value' | {rule: 'rule', value: Array|String|Object, message: String}, 'rule:in,val1&val2&val3'
     * @return {Rule}
     */
    constructor (key, rule, data, options = {}) {
        this.key = key;
        this.data = data;
        let value = '';
        this.options = Object.assign(Rule.defaultOptions, options);
        this.arguments = arguments;
        switch (typeof rule) {
        case 'string':
            if(rule.includes(':')){
                this.rule = rule.slice(0, rule.indexOf(':'));
                value = rule.slice(rule.indexOf(':')+1);
            } else {
                this.rule = rule;
            }
            break;
            case 'object':
                value = rule.value;
                this.rule = rule.rule;
                this.customMessage = rule.message;
                if (rule.options) {
                    this.options = Object.assign(this.options, rule.options);
                }
                break;
            default:
                Fnc.log_error('constructor Rule with arguments:', arguments, 'typeof rule support only string and object but', typeof rule, 'found');
                break;
        }
        // log('Constructor of rules with arguments:', arguments, 'value:', value);
        if (value != null) {
            switch (value.constructor.name) {
            case 'String':
                if(value.includes(this.options.valueSeparator)){
                    this.value = value.split(this.options.valueSeparator);
                } else {
                    this.value = value;
                }
                break;
            case 'Array':
                this.value = value;
                break;
            default:
                Fnc.log_error('constructor Rule with arguments:', arguments, 'typeof value support only string and array but', value.constructor.name, 'found. value:', value);
                break;
            }
        }
        this.isValid = true;
        this.messages = '';
        this.evaluate();
    }
    evaluate () {
        switch (this.rule) {
        case validationRules.gt.rule:
            if (Number(this.data) != this.data || this.data <= this.value) {
                this.failValidation('gt');
            }
            break;
        case validationRules.gte.rule:
            if (Number(this.data) != this.data || this.data < this.value) {
                this.failValidation('gte');
            }
            break;
        case validationRules.lt.rule:
            if (Number(this.data) != this.data || this.data >= this.value) {
                this.failValidation('lt');
            }
            break;
        case validationRules.lte.rule:
            if (Number(this.data) != this.data || this.data > this.value) {
                this.failValidation('lte');
            }
            break;
        case validationRules.min.rule:
            if (String(this.data) != this.data || this.data.length < this.value.length) {
                this.failValidation('min');
            }
            break;
        case validationRules.max.rule:
            if (String(this.data) != this.data || this.data.length > this.value.length) {
                this.failValidation('max');
            }
            break;
        case validationRules.in.rule:
            if (!this.value.includes(this.data)) {
                this.failValidation('in');
            }
            break;
        case validationRules.type.rule:
            let rule = new Rule(
                'type',
                {rule: 'in', value: this.value},
                typeof data,
                {
                    valueSeparator: this.options.typeSeparator,
                    replaceOnMessages: [{search: 'key', replace: this.key}]
                }
            )
            this.isValid = rule.isValid;
            this.messages = rule.messages;
            break;
        case validationRules.required.rule:
            if (Fnc.alt(this.data, undefined) == undefined){
                this.failValidation('required');
            }
            break;
        case validationRules.email.rule:
            if (!this.data.match(new RegExp('([a-z]|\d|\.|\-|_){5,}@([a-z]|\d|-){3,}\.([a-z]){2,}', 'g'))) {
                this.failValidation('email')
            }
            break;
        case validationRules.date.rule:
            let date = Date.parse(this.data);
            if (date instanceof Date) {
                this.failValidation('date');
            }
            break;
        case validationRules.boolean.rule:
            if ((this.value instanceof Boolean && this.data != this.value) || ('' + this.data != '' + this.value)){
                this.failValidation('boolean');
            }
            break;
        case validationRules.optional.rule:
            break;
        default:
            Fnc.log_error('Rule evaluate, rule:', this.rule, 'is not supported yet. rule:', this);
            break;
        }
    }
    makeMessage (k) {
        let text = this.customMessage || validationRules.[k].message,
            needles = [...this.options.replaceOnMessages, {search: 'key', replace: this.key}, {search: 'value', replace: this.value}, {search: 'data', replace: this.data}];

        for (let needle of needles) {
            text = text.replace('__'+needle.search+'__', needle.replace)
        }
        this.messages = text;
    }
    failValidation (rule) {
        this.makeMessage(rule);
        this.isValid = false;
    }
    get isRequired () {
        return this.rule == validationRules.required.rule;
    }
    get isOptional () {
        return this.rule == validationRules.optional.rule;
    }
}

class Validation {
    static defaultOptions = {};
    constructor (key, datas, rules_set, options = {rulesOptions: {}}) {
        // log('create new Validation with arguments:', arguments);
        let rules = rules_set.map(el => new Rule(key, el, datas[key], options.rulesOptions)).sort((a, b) => a.priority-b.priority);
        if (rules.filter(el=>el.priority == 0).length > 1) {
            rules = rules.slice(1);
        }
        this.warnings = [];
        let messages = [], warnings = [], isValid = true;
        this.isOptional = rules[0].isOptional;
        this.isRequired = rules[0].isRequired;
        this.options = Object.assign(options, Validation.defaultOptions);
        let valueExists = !!datas[key];

        if (datas.hasOwnProperty(key) && !['', undefined, null].includes(datas[key])) {
            for (const rule of rules) {
                isValid = isValid && rule.isValid;
                if(rule.messages.length > 0) {
                    messages.push([rule.messages].flat(2));
                }
            }
        } else if (!this.isOptional) {
            messages = [`Field ${key} is required`];
            isValid = false;
        } else {
            this.missingProps = true;
        }
        this.messages = messages.flat(2);
        this.rules = rules;
        this.datas = datas;
        this.isValid = isValid;
    }
}

class Validator {
    static defaultOptions = {rulesSeparator: '||', validationOptions: {}};

    constructor (datas, objectRules, options = {}){
        this.datas = datas;
        this.objectRules = objectRules;
        this.options = Object.assign(options, Validator.defaultOptions);
        this.missingProps = [];
        this.validate();
    }

    /**
     * @param  {Object objectRules} {key_1: rules_1, key_2: rules_2, ..., key_n: rules_n}
     *      {Array|String rules} 'rule_1:val_1||rule_2:val_2||...||rule_n:val_n' or [{rule: 'rule_1', value: Array|String|Object, messages: {"rule_1": String}}]
     * @return {Object validator} {isValid: Boolean, messages: [String]}
     */
    validate () {
        this.isValid = true;
        this.messages = [];
        this.warnings = [];
        this.messagesKey = {};
        for (const key in this.objectRules) {
            if (!this.datas.hasOwnProperty(key)) {
                this.missingProps.push(key);
            }
            let rules = this.objectRules[key], rules_set = [];
            switch (rules.constructor.name) {
                case 'String':
                    rules_set = rules.split(this.options.rulesSeparator);
                    break;
                case 'Array':
                    rules_set = rules;
                    break;
                default:
                    // statements_def
                    break;
            }
            let validations = new Validation(key, this.datas, rules_set, this.options.validationOptions);
            this.isValid = this.isValid && validations.isValid;

            if (validations.messages.length > 0) {
                this.messagesKey[key] = validations.messages.flat();
                this.messages.push(...validations.messages.flat());
            }
            this.warnings.push(...validations.warnings.flat());
            this.validations = validations;
        }
    }

    /**
     * @param  {String key}
     * @param  {String||[Object] rules} 'rule_1:val_1||rule_2:val_2||...||rule_n:val_n' or [{rule: 'rule_1', value: Array|String|Object, messages: {"rule_1": String}}]
     * @return {Object {isValid: Boolean, messages: [String]}}
     */
}

export default Validator;